import { Avatar } from "primereact/avatar";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Logo from "../../Components/PrimeReact/logo";
import IndexSummary from "../../Components/PrimeReact/MarketSummary/indexSummary";
import DisclosureScroller from "../../Components/TextScroller/disclosureScoller";
import { DateTimer } from "../../Components/Timer/dateTimer";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { retrieveStockScreen2, retrieveStockScreen2Data, retrieveStockSession } from "../../Services/StockSessionApiService";
import ChangeSign from "../../Components/PrimeReact/changeSign";
import { useAuthHeader, useSignOut } from "../../auth/AuthService";
import { useNavigate } from "react-router-dom";
import IndexSummaryDataDisplay from "../../Components/PrimeReact/MarketSummary/indexSummaryDataDisplay";

export default function Screen2() {
    const {t, i18n} = useTranslation();
    const [stocks, setStocks] = useState([]);
    const [ytdStocks, setYtdStocks] = useState([]);
    const authHeader = useAuthHeader();

    var START = 1;
    var MARKET_CLOSING = 99;
    const [STATE, setSTATE] = useState(START);
    const [ROTATE, setROTATE] = useState(false);
    const [offset, setOffset] = useState(0);
    const [nextBoard, setNextBoard] = useState();
    const [board, setBoard] = useState();
    const [lang, setLang] = useState();
    const signOut = useSignOut();
    const navigator = useNavigate();

    const logoutFunction = () => {
        if (signOut()) {
            navigator('/login');
        }
    }
    function rotateNext() {
        setROTATE(!ROTATE); 
    }

    async function init() {
        let rotateTime;
        await retrieveStockScreen2({m_type: nextBoard, offset: offset, perPage: 7}, authHeader())
        .then((response) => {
            let data =response.data.data;
            rotateTime = data?.setting?.rotateTime;
            let lang = data?.setting?.language == "cat" ? "kh" : "en";
            setLang(lang);
            i18n.changeLanguage(lang);

            setNextBoard(data?.setting?.nextBoard);
            setOffset(data?.offset);
        })
        .catch((error) => {
            console.log(error);
            if (error?.response?.status === 403) {
                logoutFunction();
            }
        });
        return rotateTime;
    }

    async function updateStockData() {
        await retrieveStockScreen2Data({m_type: nextBoard, offset: offset, perPage: 7}, authHeader())
        .then((response) => {
            let data = response.data.data.data;
            let dataYtd = response.data.data.dataYtd;
            let stockDataArr = []; 
            let stockDataYtdArr = []; 
            setBoard(response.data.data?.board);
            Object.values(data).sort((a, b) => (a?.esymbol > b?.esymbol) ? 1 : -1).map((v, i) => {
                stockDataArr[i] =v;
            });
            Object.values(dataYtd.issueYtd).sort((a, b) => (a?.esymbol > b?.esymbol) ? 1 : -1).map((v, i) => {
                stockDataYtdArr[i] = v;
                stockDataYtdArr[i]['icode'] = v.icode;
            });
            if (stockDataArr.length < 7) {
                let length = 7 - stockDataArr.length;
                for (let step = 0; step < length; step++) {
                    stockDataArr.push({value: 'none'})
                }
            } 
            if (stockDataYtdArr.length < 7) {
                let length = 7 - stockDataYtdArr.length;
                for (let step = 0; step < length; step++) {
                    stockDataYtdArr.push({value: 'none'})
                }
            } 
            setStocks(stockDataArr);
            setYtdStocks(stockDataYtdArr)
        })
        .catch((error) => {
            console.log(error);
            if (error?.response?.status === 403) {
                logoutFunction();
            }
        });
        // check();
    }

    async function check() {
        await retrieveStockSession(authHeader())
        .then((response) => {
            response.data.data.session && setSTATE(MARKET_CLOSING);
        })
        .catch((error) => {
            if (error.response.status === 403) {
                logoutFunction();
            }
        });
    }

    useEffect(() => {
        // updateStockData();
        // let dataInterval = setInterval(updateStockData, 5000);
        // if (STATE == MARKET_CLOSING || (new Date().setHours(15,10,0)) < (new Date().getTime())) {
        //     clearInterval(dataInterval);
        // }

        // return () => {
        //     clearInterval(dataInterval);
        // }
    },[ROTATE, STATE]);

    useEffect(() => {
        let rotateTime = async () => await init();
        var intervalRotate;
        rotateTime().then((e) => {
            e && (intervalRotate = setInterval(rotateNext, e * 1000))
            updateStockData();
            if (!(STATE == MARKET_CLOSING || (new Date().setHours(15,10,0)) < (new Date().getTime()))) {
                for (let i = 5000; i <= (e * 1000) - 5000; i+=5000) {
                    setTimeout(updateStockData, i);
                }
            }
        });
        return () => {
            clearInterval(intervalRotate);
        }
    },[ROTATE, STATE])

    const stockBodyTemplate = (rowData) =>  {
        if (rowData?.value === 'none') {
            return <span>&nbsp;<img src="/img/LP-Logo.png" className="opacity-0 vertical-align-super w-1rem"></img></span>;
        }
        return (
            <div className="flex align-items-center relative">
                <Avatar image={`/img/issue_logo_icons/${rowData?.icode}_logo.jpg`} shape="circle" style={{width:"20px", height:"20px"}}/>
                <span className="font-bold ml-2">{rowData?.esymbol}&nbsp;<img src="/img/LP-Logo.png" className={(rowData?.lp != 0 ? '' : 'opacity-0 ') + "vertical-align-super w-1rem"}></img></span>
            </div>
        );
    }
    const basePriceBodyTemplate = (rowData) =>  {
        if (rowData?.value === 'none') {
            return '';
        }
        return (
            <div className="flex justify-content-end">
                <span className="flex">{rowData?.bprice?.toLocaleString('en-US')}</span>
            </div>
        );
    }
    const expPriceBodyTemplate = (rowData) =>  {
        if (rowData?.value === 'none') {
            return '';
        }
        return (
            <div className="flex align-items-center justify-content-end">
                <span className='flex'>{rowData?.etprice ? rowData?.etprice?.toLocaleString('en-US') : '-'}</span>
            </div>
        );
    }
    const expQtyBodyTemplate = (rowData) =>  {
        if (rowData?.value === 'none') {
            return '';
        }
        return (
            <div className="flex align-items-center justify-content-end">
                <span className='flex'>{rowData?.etquantity ? rowData?.etquantity?.toLocaleString('en-US') : '-'}</span>
            </div>
        );
    }
    const bidBodyTemplate = (rowData) =>  {
        if (rowData?.value === 'none') {
            return '';
        }
        return (
            <div className="flex align-items-center justify-content-end">
                <span className={(rowData.fsbpqprice == rowData.bprice || !rowData.fsbpqprice ? "text-white" : (rowData.fsbpqprice < rowData.bprice ? "text-red" : "text-green")) + " flex"}>{rowData?.fsbpqprice ? rowData?.fsbpqprice?.toLocaleString('en-US') : '-'}</span>
            </div>
        );
    }
    const askBodyTemplate = (rowData) =>  {
        if (rowData?.value === 'none') {
            return '';
        }
        return (
            <div className="flex align-items-center justify-content-end">
                <span className={(rowData.fsspqprice == rowData.bprice || !rowData.fsspqprice ? "text-white" : (rowData.fsspqprice < rowData.bprice ? "text-red" : "text-green")) + " flex"}>{rowData?.fsspqprice ? rowData?.fsspqprice?.toLocaleString('en-US') : '-'}</span>
            </div>
        );
    }
    const openBodyTemplate = (rowData) =>  {
        if (rowData?.value === 'none') {
            return '';
        }
        return (
            <div className="flex align-items-center justify-content-end">
                <span className={(rowData.oprice == rowData.bprice || rowData.oprice == 0 ? "text-white" : (rowData.oprice < rowData.bprice ? "text-red" : "text-green")) + " flex"}>{rowData?.oprice ? rowData?.oprice?.toLocaleString('en-US') : '-'}</span>
            </div>
        );
    }
    const lastBodyTemplate = (rowData) =>  {
        if (rowData?.value === 'none') {
            return '';
        }
        return (
            <div className="flex align-items-center justify-content-end">
                <span className={(rowData.cprice == rowData.bprice || rowData.cprice == 0 ? "text-white" : (rowData.cprice < rowData.bprice ? "text-red" : "text-green")) + " flex"}>{rowData?.cprice ? rowData?.cprice?.toLocaleString('en-US') : '-'}</span>
            </div>
        );
    }
    const changeBodyTemplate = (rowData) =>  {
        if (rowData?.value === 'none') {
            return '';
        }
        return (
            <div className="flex align-items-center justify-content-end">
                <span className={(rowData.cpday == 0 ? "text-white" : (rowData.cpday < 0 ? "text-red" : "text-green")) + " flex w-full justify-content-start"}>
                    <span className="flex w-8 justify-content-end">
                        <ChangeSign 
                            change = {rowData.cpday}
                            vol_qty = {rowData.ctquantity}
                            base_price = {rowData.bprice}
                            last_price = {rowData.cprice}
                            lower_price = {rowData.llprice}
                            upper_price = {rowData.hlprice}
                        />
                    </span>
                    <span className="flex w-4 justify-content-start">
                        {Math.abs(rowData?.cpday)}
                    </span>
                </span>
            </div>
        );
    }
    const highBodyTemplate = (rowData) =>  {
        if (rowData?.value === 'none') {
            return '';
        }
        return (
            <div className="flex align-items-center justify-content-end">
                <span className={(rowData.chigh == rowData.bprice || !rowData.chigh ? "text-white" : (rowData.chigh < rowData.bprice ? "text-red" : "text-green")) + " flex"}>{rowData?.chigh ? rowData?.chigh?.toLocaleString('en-US') : '-'}</span>
            </div>
        );
    }
    const lowBodyTemplate = (rowData) =>  {
        if (rowData?.value === 'none') {
            return '';
        }
        return (
            <div className="flex align-items-center justify-content-end">
                <span className={(rowData.clow == rowData.bprice || !rowData.clow ? "text-white" : (rowData.clow < rowData.bprice ? "text-red" : "text-green")) + " flex"}>{rowData?.clow ? rowData?.clow?.toLocaleString('en-US') : '-'}</span>
            </div>
        );
    }
    const volumeBodyTemplate = (rowData) =>  {
        if (rowData?.value === 'none') {
            return '';
        }
        return (
            <div className="flex align-items-center justify-content-end">
                <span className="flex">{rowData?.ctquantity?.toLocaleString('en-US')}</span>
            </div>
        );
    }
    const valueBodyTemplate = (rowData) =>  {
        if (rowData?.value === 'none') {
            return '';
        }
        return (
            <div className="flex align-items-center justify-content-end">
                <span className="flex">{rowData?.ctamount?.toLocaleString('en-US')}</span>
            </div>
        );
    }
    const peBodyTemplate = (rowData) =>  {
        if (rowData?.value === 'none') {
            return <span>&nbsp;</span>;
        }
        return (
            <div className="flex align-items-center justify-content-end">
                <span className="flex">{rowData?.pe?.toLocaleString('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 }) ?? '-'}</span>
            </div>
        );
    }
    const mkCapBodyTemplate = (rowData) =>  {
        return (
            <div className="flex align-items-center justify-content-end">
                <span className="flex">{rowData?.marketCap?.toLocaleString('en-US', { maximumFractionDigits: 0})}</span>
            </div>
        );
    }
    const fmkCapBodyTemplate = (rowData) =>  {
        return (
            <div className="flex align-items-center justify-content-end">
                <span className="flex">{rowData?.fullMarketCap?.toLocaleString('en-US', { maximumFractionDigits: 0})}</span>
            </div>
        );
    }
    const highlBodyTemplate = (rowData) =>  {
        return (
            <div className="flex align-items-center justify-content-end">
                <span className={(rowData.hprice == rowData.bprice || !rowData.hprice ? "text-white" : (rowData.hprice < rowData.bprice ? "text-red" : "text-green")) + " flex"}>{rowData?.hprice?.toLocaleString('en-US')}</span>
            </div>
        );
    }
    const lowlBodyTemplate = (rowData) =>  {
        return (
            <div className="flex align-items-center justify-content-end">
                <span className={(rowData.lprice == rowData.bprice || !rowData.lprice ? "text-white" : (rowData.lprice < rowData.bprice ? "text-red" : "text-green")) + " flex"}>{rowData?.lprice?.toLocaleString('en-US')}</span>
            </div>
        );
    }
    const closeBodyTemplate = (rowData) =>  {
        return (
            <div className="flex align-items-center justify-content-end">
                <span className={(rowData.cprice == rowData.bprice ? "text-white" : (rowData.cprice < rowData.bprice ? "text-red" : "text-green")) + " flex"}>{rowData?.cprice?.toLocaleString('en-US')}</span>
            </div>
        );
    }
    const changeYtdBodyTemplate = (rowData) =>  {
        if (rowData?.value === 'none') {
            return <span>&nbsp;</span>;
        }
        return (
            <div className="flex w-full align-items-center justify-content-end">
                <span className={(rowData.change == 0 ? "text-white" : (rowData.change < 0 ? "text-red" : "text-green")) + " flex w-full justify-content-start"}>
                    <span className="flex w-8 justify-content-end">
                        <ChangeSign  
                            change = {rowData.change}
                            vol_qty = {rowData.ctquantity}
                            base_price = {rowData.bprice}
                            last_price = {rowData.cprice}
                            lower_price = {rowData.llprice}
                            upper_price = {rowData.hlprice}
                        />
                    </span>
                    <span className="flex w-4">{Math.abs(rowData?.change)}</span>
                </span>
            </div>
        );
    }
    return (
        <div className='relative md:h-screen'>
            <div className="flex align-items-center h-full">
                <div className="flex justify-content-center shadow-2 h-full bg-screen">
                    <div className='flex w-12 justify-content-center px-3'>
                        <div className="grid w-full">
                            <div className="col-12 text-white">
                                <div className='grid'>
                                    <div className="col-4 h-6rem md:h-full">
                                        <Logo />
                                    </div>
                                    <IndexSummaryDataDisplay STATE={1}/>
                                    <div className="col-4 flex align-items-center">
                                        <div className="grid w-full md:text-3xl">
                                            <div className={(i18n.language == 'kh' ? 'py-0' : '' ) +' col-12 flex justify-content-end'}>
                                                <DateTimer type={1}/>
                                            </div>
                                            <div className={(i18n.language == 'kh' ? 'py-0' : '' ) +' col-12 flex justify-content-end'}>
                                                {t('Time')}:<DateTimer type={2}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='md:-mt-6 col-12'>
                                <div><span className="md:text-2xl pl-2 font-bold">{t('Real Time Quotation')}</span></div>
                                <div className="card px-4 py-3 shadow-1 border-round-lg bg-card">
                                    <DataTable value={stocks} className="text-white w-full" tableClassName="bg-none">
                                        <Column field="esymbol" header={t(board)} body={stockBodyTemplate} className="border-blue-700 text-white w-2 lg:w-1" headerClassName=" p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="bprice" align="right" header={t("Base Price")} body={ basePriceBodyTemplate} className="border-blue-700 text-white p-0" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="etprice" align="right" header={t("Exp. Price")} body={expPriceBodyTemplate} className="border-blue-700 text-white" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="etquantity" align="right" header={t("Exp. Qty")} body={expQtyBodyTemplate} className="border-blue-700 text-white" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="fsbpqprice" align="right" header={t("Bid")} body={bidBodyTemplate} className="border-blue-700 text-white" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="fsspqprice" align="right" header={t("Ask")} body={askBodyTemplate} className="border-blue-700 text-white" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="oprice" align="right" header={t("Open")} body={openBodyTemplate} className="border-blue-700 text-white" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="cprice" align="right" header={t("Last")} body={lastBodyTemplate} className="border-blue-700 text-white" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="cpday" align="right" header={t("Change")} body={changeBodyTemplate} className="border-blue-700 text-white" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="chigh" align="right" header={t("High")} body={highBodyTemplate} className="border-blue-700 text-white" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="clow" align="right" header={t("Low")} body={lowBodyTemplate} className="border-blue-700 text-white" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="ctquantity" align="right" header={t("Volume")} body={volumeBodyTemplate} className="border-blue-700 text-white" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="ctamount" align="right" header={t("Value")} body={valueBodyTemplate} className="border-blue-700 text-white" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="pe" align="right" header={t("P/E")} body={peBodyTemplate} className="border-blue-700 text-white" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-right text-xs md:text-lg" style={{background: 'none'}}></Column>
                                    </DataTable>
                                </div>
                            </div>

                            <div className='md:-mt-6 col-12'>
                                <div><span className="md:text-2xl pl-2 font-bold">{t('Previous Day Trade Summary')}</span></div>
                                <div className="card px-4 py-3 shadow-1 border-round-lg bg-card">
                                    <DataTable value={ytdStocks} className="text-white w-full" tableClassName="bg-none">
                                        <Column field="esymbol" header={t(board)} body={stockBodyTemplate} className="border-blue-700 text-white w-2 lg:w-1" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="bprice" align="right" header={t("Base Price")} body={basePriceBodyTemplate} className="border-blue-700 text-white p-0" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="oprice" align="right" header={t("Open")} body={openBodyTemplate} className="border-blue-700 text-white" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="chigh" align="right" header={t("High")} body={highlBodyTemplate} className="border-blue-700 text-white" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="clow" align="right" header={t("Low")} body={lowlBodyTemplate} className="border-blue-700 text-white" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="cprice" align="right" header={t("Close")} body={closeBodyTemplate} className="border-blue-700 text-white" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="change" align="right" header={t("Change")} body={changeYtdBodyTemplate} className="border-blue-700 text-white" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="ctquantity" align="right" header={t("Volume")} body={volumeBodyTemplate} className="border-blue-700 text-white" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="ctamount" align="right" header={t("Value")} body={valueBodyTemplate} className="border-blue-700 text-white" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="pe" align="right" header={t("P/E")} body={peBodyTemplate} className="border-blue-700 text-white" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="marketCap" align="right" header={t("Market Cap. (M)")} body={mkCapBodyTemplate} className="border-blue-700 text-white" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                        <Column field="fullMarketCap" align="right" header={t("Full Market Cap. (M)")} body={fmkCapBodyTemplate} className="border-blue-700 text-white" headerClassName="p-0 text-xs md:text-lg" bodyClassName="p-0 py-1 text-xs md:text-lg" style={{background: 'none'}}></Column>
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid py-1 shadow-2 w-full absolute bottom-0 bg-card hidden-print">
                <div className={ (i18n.language == 'kh' ? 'py-0' : '' ) + " col-12"}>
                    {lang && <DisclosureScroller />}
                </div>
            </div>
        </div>
    )
}